import { KommissionNotizMitarbeiterResponse } from '@/types/service-response'

export class CommissionNoteEmployee {
  public constructor (
    readonly id: number,
    readonly lastName: string,
    readonly firtName: string,
    readonly fullName: string,
    readonly shortName: string,
  ) {}

  static createFromResponse (responseData: KommissionNotizMitarbeiterResponse[]): Array<CommissionNoteEmployee> {
    let result: Array<CommissionNoteEmployee> = []
    if (responseData) {
      result = responseData.map((item: KommissionNotizMitarbeiterResponse ) => {
        return new CommissionNoteEmployee(
          item.ID,
          item.Name ? item.Name : '',
          item.Vorname ? item.Vorname : '',
          item.VollerName ? item.VollerName : '',
          item.Kurzzeichen ? item.Kurzzeichen : '',
        )
      })
    }
    return result
  }
}
